import { Badge } from "@dl/web-core-js/ui";
import type { TFunction } from "i18next";
import { useTranslation } from "react-i18next";
import type { ServiceInternalReason, ServiceOrderStatus } from "../../api/servicedesk";

/** A service order's status: blue while open, green once sent, red if it never was. */
export function ServiceStatusBadge({ status }: { status: ServiceOrderStatus }) {
  const { t } = useTranslation();
  const variant = { OPEN: "info", CLOSED: "success", CANCELLED: "error" } as const;
  return (
    <Badge variant={variant[status]} size="sm">
      {serviceStatusLabel(t, status)}
    </Badge>
  );
}

export function serviceStatusLabel(t: (key: string, fallback: string) => string, status: ServiceOrderStatus): string {
  return {
    OPEN: t("sd.status.open", "Open"),
    CLOSED: t("sd.status.closed", "Closed"),
    CANCELLED: t("sd.status.cancelled", "Cancelled"),
  }[status];
}

/** Labels for the internal reasons, shared by the dialog and the order page. */
export function internalReasonLabel(t: TFunction, reason: ServiceInternalReason): string {
  switch (reason) {
    case "PLANT_NEED":
      return t("sd.reason.plant", "Plant need");
    case "SHOWROOM":
      return t("sd.reason.showroom", "Showroom");
    case "SERVICE_STOCK":
      return t("sd.reason.stock", "Service stock");
    default:
      return t("sd.reason.other", "Other");
  }
}
